module.exports = __webpack_public_path__ + "static/media/repay-CELO.5b171b09.svg";